import { render, staticRenderFns } from "./ShippingOption.vue?vue&type=template&id=573f8bda"
import script from "./ShippingOption.vue?vue&type=script&lang=js"
export * from "./ShippingOption.vue?vue&type=script&lang=js"
import style0 from "./ShippingOption.vue?vue&type=style&index=0&id=573f8bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports